import { render, staticRenderFns } from "./estado-proceso.vue?vue&type=template&id=93e36d46&scoped=true&"
import script from "./estado-proceso.component.ts?vue&type=script&lang=ts&"
export * from "./estado-proceso.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e36d46",
  null
  
)

export default component.exports